<template>
<div id="app-loader" ref="app-loader" class="text-center my-3">
    <div ref="spinner" class="app-loader__spinner">
        <div :style="{ background : `${color} `}"></div>
        <div :style="{ background : `${color} `}"></div>
        <div :style="{ background : `${color} `}"></div>
        <div :style="{ background : `${color} `}"></div>
        <div :style="{ background : `${color} `}"></div>
        <div :style="{ background : `${color} `}"></div>
        <div :style="{ background : `${color} `}"></div>
        <div :style="{ background : `${color} `}"></div>
        <div :style="{ background : `${color} `}"></div>
        <div :style="{ background : `${color} `}"></div>
        <div :style="{ background : `${color} `}"></div>
        <div :style="{ background : `${color} `}"></div>
        <!-- <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div> -->
    </div>
    <br><slot></slot>
</div>
</template>
<script>
/* eslint-disable */
export default {
    props: ['color'],
    name: 'spinner',
};
</script>
